const UNITS = [
    'B',
    'kB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
];

export function formaterByteSomLesbarStreng(antallByte: number): string {
    const exponent = Math.min(Math.floor(Math.log10(antallByte) / 3), UNITS.length - 1);
    antallByte = Number((antallByte / Math.pow(1000, exponent)).toPrecision(3));
    const numberString = antallByte.toLocaleString() 

    const unit = UNITS[exponent];

    return numberString + ' ' + unit;
}
